<template>
  <div class="no-results-cmp">
    <div class="no-results-icon">
      <v-icon :size="iconSize" color="#d0d5d8">{{icon}}</v-icon>
    </div>
    <div class="no-results-text">{{text}}</div>

    <div class="no-results-text action-text"
         v-if="actionText"
         @click="actionClick">
      {{actionText}}
    </div>

  </div>
</template>

<script>
export default {
  name: 'NoResultsCmp',
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    actionText: {
      type: String,
      required: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconSize() {
      return this.isMobile ? "32px" : "46px"
    }
  },
  methods: {
    actionClick() {
      this.$emit('action-click');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.no-results-cmp {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .no-results-icon {
    margin-bottom: 14px;
  }

  .no-results-text {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-weight: 600;
    color: $grey-color-6;

    &.action-text {
      color: $blue-color-4;
      cursor: pointer;
    }
  }
}
</style>
